import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import { openModal, closeModal } from '../../../../../store/Modal/actions'
import { deleteTracks, downloadTracks, saveTracksRef, toggleSelectedTrack } from '../../../../../store/Tracks/actions'

import Collapsible from '../../../../../components/Space/Collapsible'
import Button from '../../../../../components/Button'
import Tracks from '../../../../../components/Tracks'

import SvgFileM from '../../../../../components/SVG/FileM'
import SvgLog from '../../../../../components/SVG/Log'
import Spinner from '../../../../../components/Spinner'
import VideoSelecetAll from './VideoSelecetAll'
import { getTracks } from '../../../../../store/Search/extraSelectors'
import { store } from '../../../../../connect'
import { deleteTimeOutClipsFromPrograms } from '../../../../../utilities/deleteTimeOutPrograms'


const Video = ({
    className = "",
    active,
    placeNumber,
    openModal,
    closeModal,
    selectedTracks = [],
    deleteTracks,
    title,
    tracksRef,
    downloadTracks,
    toggleSelectedTrack,
    toggleHideEnded,
    loading
}) => {


    //let title = 'Ролики'
    //if (selectedTracks.length > 1) title += ` {<span>${selectedTracks.length}</span>}`
    const handleDelete = () => {

        try {
            const themeRefs = Object.values(tracksRef);
            for (const themeRef of themeRefs) {
                if (themeRef.current)
                    themeRef.current.hStop()
            }


        }
        catch (tracksRefError) {
            console.log({ tracksRefError });

        }

        openModal({
            type: "confirm",
            size: "sm",
            data: {
                title: "Вы точно хотите удалить выделенные ролики?",
                buttons: {
                    cancel: {
                        title: "Вернуться",
                        onClick: () => closeModal("confirm")
                    },
                    confirm: {
                        title: "Удалить",
                        onClick: () => {
                            deleteTracks(selectedTracks)
                            closeModal("confirm")
                        }
                    }
                }
            }
        })
    }

    const toggleSelectedAll = () => {
        const state = store.getState();

        const hideEnded = state.tracks.hideEnded

        let clips = getTracks(state)

        if (hideEnded)
            clips = clips.filter(track => !track.clipEnded)

        clips = clips.map(el => el.id)

        console.log({clips, hideEnded});
        

        toggleSelectedTrack({ ids: clips, simple: true })

    }
    const toggleUnselectedAll = () => {


        toggleSelectedTrack({ ids: [], simple: true })


    }

    return (
        <>
            <Collapsible
                active={active}
                id={111}
                className={`CollapsibleVideo ${className}`}
                title={<>{title} {selectedTracks.length > 1 ? <small className='badge badge-light'>{selectedTracks.length}</small> : ''}</>}
                placeNumber={placeNumber}
                elements={
                    <>
                        {/* <Button
                            type="string"
                            disabled={ (selectedTracks[0] && !selectedTracks[1]) ? false : true }
                            onClick={ () => openModal({
                                type: "videoHistory",
                                size: "md"
                            }) }
                        >
                            <SvgLog/>
                        </Button> */}
                        <Button
                            type="string"
                            disabled={(selectedTracks[0] && !selectedTracks[1]) ? false : true}
                            onClick={() => openModal({
                                type: "mediaplan",
                            })}
                        >
                            <SvgFileM /> Медиаплан
                        </Button>
                    </>
                }
                // elementsLeft={}
                buttons={{
                    select: {
                        on: true,
                        title: "Выделить все отображённые",
                        onClick: toggleSelectedAll
                    },
                    cancel: {
                        on: true,
                        title: "Очистить выбор",
                        onClick: toggleUnselectedAll
                    },
                    add: {
                        on: true,
                        title: "Добавить ролик",
                        onClick: () => openModal({
                            type: "adsCreate",
                        })
                    },
                    download: {
                        on: true,
                        disabled: (selectedTracks[0]) ? false : true,
                        onClick: () => downloadTracks({ tracksIds: selectedTracks })
                    },
                    edit: {
                        on: true,
                        disabled: (selectedTracks[0] && !selectedTracks[1]) ? false : true,
                        onClick: () => openModal({
                            type: "adsEditPrepare",
                        })
                    },
                    remove: {
                        on: true,
                        // disabled: (selectedTracks[0]) ? false : true,
                        onClick: handleDelete
                    }
                }}
            >
                {loading ? <Spinner className="pt-xs pb-xs" /> : <Tracks toggleHideEnded={toggleHideEnded} />}


            </Collapsible>
        </>
    )
}

const stateToProps = state => {
    const ids = state.tracks.tracks.map(tr => tr.id)
    
    return {
        loading: state.tracks.tracks.length ? false : state.objects.loading,
        selectedTracks: state.tracks.selected.filter(id => ids.includes(id)),
        tracksRef: state.tracks.tracksRef
    }
}

const actionsToProps = {
    openModal, closeModal, deleteTracks, downloadTracks, saveTracksRef, toggleSelectedTrack
}

export default connect(stateToProps, actionsToProps)(Video)